import { Pipe, PipeTransform } from '@angular/core';
/**
 * Append text pipe
 */
@Pipe({ name: 'appendText' })
export class AppendTextPipe implements PipeTransform {
  /**
   * Append text pipe
   * @param value Input value (string)
   * @param appendText Text to append
   * @param skipAppendOnEmpty Don't append text if value is empty (undefined, null or empty string)
   * @param lpadSpacesCount Leftpad lpadSpacesCount spaces to appendText
   */
  transform(value: string, appendText: string, skipAppendOnEmpty = false, lpadSpacesCount = 0): string {
    if (!value && skipAppendOnEmpty) {
      return value;
    }

    return (value || '') + ' '.repeat(lpadSpacesCount) + (appendText || '');
  }
}

